import { Typography } from '@mui/material';
import PublicToolLayout from '../../components/public-tools/PublicToolLayout';
import ToolWidget from '../../components/public-tools/ToolWidget';

export default function SchemaDetectorPage() {
  return (
    <PublicToolLayout title="Schema Detector">
      <Typography variant="h5" fontWeight={700} gutterBottom>
        Schema / JSON-LD Detector
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        Enter a page URL to detect JSON-LD, Microdata, and RDFa structured data markup and
        identify the schema types present.
      </Typography>
      <ToolWidget
        scanType="SCHEMA"
        formLabel="Page URL"
        formPlaceholder="https://example.com/your-page"
      />
    </PublicToolLayout>
  );
}
